// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ProfileEmptyState-cls1__ab159258be923dc8b1f3{/*!*/}.ProfileEmptyState-cls2___24e1d4037936a835076{font-family:\"Roboto\",Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:20px;color:#535366}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ProfileEmptyState-cls1__ab159258be923dc8b1f3",
	"cls2": "ProfileEmptyState-cls2___24e1d4037936a835076 ProfileEmptyState-cls1__ab159258be923dc8b1f3"
};
export default ___CSS_LOADER_EXPORT___;
